<div class="page-wrapper pre-auth-page">
  <div class="container-fluid flex-grow-1">
    <div class="row g-0">
      <div class="col-12 p-0">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>